import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const FolderPage_OneFolder_QueryDocument = graphql(`
  query FolderPage_OneFolder_Query($id: Id!) {
    findOneFolder(id: $id) {
      _id
      code

      consolidation {
        title
        ...FolderBusinessEntity_FolderBusinessEntityConsolidation_Fragment
        ...UiSettingsContext_QuotationEmitters_Fragment
      }

      ...FolderPage_Tabs_Folder_Fragment
      ...FolderArchiveInfoDialog_Folder_Fragment
      ...NavigationContext_FolderSpaceInfo_Folder_Fragment
      ...MissionForm_FolderConfidentiality_Fragment
    }
  }
`);

export type FolderPage_OneFolder = ResultOf<
  typeof FolderPage_OneFolder_QueryDocument
>['findOneFolder'];

export const useFindOneFolderQuery = (id = EMPTY_ID) =>
  useGraphQLQuery(
    FolderPage_OneFolder_QueryDocument,
    { id },
    { enabled: !!id },
  );
